import React, { useState } from 'react';

import classNames from 'classnames';
import { Input } from 'antd';

type Props = {
    label: string;
    value?: string;
    maxLength: number;
    onChange: (value: any) => void;
    onFocus: () => void;
    inputError: any;
    customClassName: string;
    disabled?: boolean;
}

const CustomSeparatedTextArea = ({ 
    label,
    value,
    maxLength,
    onChange,
    onFocus,
    inputError,
    customClassName,
    disabled,
}: Props) => {
    const { TextArea } = Input;

    const [isFocused, setIsFocused] = useState<boolean>(false);

    return (
        <>
            <div className={classNames(`${customClassName} gx-flex-column`, {"is-filled": isFocused || value, "is-focused": isFocused, "is-error": !!inputError, "is-disabled": disabled})}>
                <label className={`${customClassName}__label`}>{label}</label>
                <TextArea
                    value={value}
                    onChange={onChange}
                    onFocus={() => {
                        if (disabled) return;
                        setIsFocused(true);
                        onFocus();
                    }}
                    onBlur={() => {
                        setIsFocused(false);
                    }}
                    maxLength={maxLength}
                    className={`${customClassName}__input`}
                    disabled={disabled}/>
            </div>
        </>
    )
}

export { CustomSeparatedTextArea };